import { ReactComponent as CheckmarkSavedIcon } from 'assets/icons/check-circle-no-color.svg';

import { useTranslation } from 'react-i18next';

import style from './SubscribtionPlans.module.scss';

const FEATURE_KEYS = [
  'featureEverythingInFree',
  'featureWhiteboardWidgets',
  'featureTemplates',
  'featureStudentAccess',
  'featureExport',
  'featureCalendar',
  'featureLessonPlanning',
];

interface iPorps {
  plans: any[];
  selectedPlan: (obj: any) => void;
  activePlanId: string;
}
export default ({ plans, selectedPlan, activePlanId }: iPorps) => {
  const { t } = useTranslation();
  return (
    <div>
      <div className={style.featureContainer}>
        {FEATURE_KEYS.map(key => (
          <div key={key} className={style.feature}>
            <CheckmarkSavedIcon />
            {t(`login:${key}`)}
          </div>
        ))}
      </div>

      <div className={style.planList}>
        {plans.map(obj => (
          <div
            key={obj.id}
            className={`${style.planItem} ${activePlanId === obj.id ? style.active : ''}`}
            onClick={() => selectedPlan(obj)}
          >
            {new Intl.NumberFormat(navigator.language, {
              style: 'currency',
              currency: obj.currency,
            }).format(obj.unit_amount / 100)}
            {' '}
            <small>
              {t('login:pricePerInterval', {
                count: obj.recurring.interval_count,
                interval: obj.recurring.interval,
              })}
            </small>
          </div>
        ))}
      </div>
    </div>
  );
};
